<template>
  <div id="app">
    <div class="contain">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {},
  destroyed() {
  },
  methods: {}
};
</script>


<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
  width: 100%;
  font-size: 16px;
}

#app {
  font-family: PingFang SC, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

.contain {
  width: 100%;
  height: 100%;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  text-align: left;
  padding-top: 0;

  .router-view {
    z-index: 1;
    text-align: center;
    height: 100%;
  }
}
</style>

